module.exports = __webpack_public_path__ + "static/result_haeundae-20f4e2969a387d4dbaf6e267fbae1a57.png";